<template>
  <div>
    <h2>Subscription & Communication</h2>

    <div class="grid-wrapper">
      <label>Email subscriptions</label>
      <button
        class="default-btn slim small text underline"
        @click="setSubscribe(!isSubscribed)"
      >
        {{ isSubscribed ? 'Unsubscribe from' : 'Subscribe to'}} marketing emails
      </button>
      <p>
        This includes discounts, promotions, newsletters and occasional
        surveys. You will still receive all other non-marketing emails based
        on your notification settings
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'UserSubscriptionForm',
  computed: {
    ...mapGetters('feathers', ['apiUsers']),
    ...mapState('authStore', {
      userData: 'userData',
    }),

    isSubscribed () {
      return this.userData.receiveResources
    },
  },
  methods: {
    ...mapActions('authStore', ['setUserData']),

    async setSubscribe (subscribe) {
      try {
        const userData = await this.apiUsers.patch(this.userData.id, {
          receiveResources: subscribe,
        })
        this.setUserData(userData)

        this.addAlert({ message: `You have successfully ${subscribe ? 'subscribed' : 'unsubscribed'}` })
      } catch (err) {
        this.addAlert({
          type: 'error',
          message: `There was an error when updating your subscription status: ${err.message}`,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-wrapper {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;

  grid-column-gap: 60px;
  grid-row-gap: 20px;

  align-items: flex-start;
  justify-content: flex-start;

  .default-btn {
    width: 290px;
    margin: 0;
  }

  @include md {
    grid-template-columns: auto 1fr;
  }
}

p {
  margin: 0;

  @include md {
    @include gridPos(2, 3, 2, 3);
  }
}
</style>
